import { Link } from "react-router-dom";

/**
 * Thin dark banner pinned above the main site header on every page (rendered
 * in SiteLayout, before <Header />). Not sticky: it scrolls away while the
 * header stays. Network-wide crisis treatment, mirrors DepressionResource.
 */
export default function CrisisBanner() {
  return (
    <div
      role="region"
      aria-label="Crisis help"
      style={{
        background: "hsl(var(--footer-bg))",
        color: "hsl(var(--footer-fg))",
      }}
      data-testid="crisis-banner"
    >
      <div className="mx-auto max-w-[1200px] px-6">
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2 text-[13px] leading-snug">
          <p className="m-0">
            If you may be in danger, call or text{" "}
            <strong style={{ color: "#F2B84B", fontWeight: 700 }}>988</strong>.
            Call <strong style={{ fontWeight: 700 }}>911</strong> for
            emergencies.
          </p>
          <Link
            to="/suicide-and-crisis"
            className="font-semibold whitespace-nowrap underline underline-offset-2 hover:no-underline"
            style={{ color: "hsl(var(--footer-fg))" }}
            data-testid="crisis-banner-link"
          >
            More crisis resources
          </Link>
        </div>
      </div>
    </div>
  );
}
